import { MessageContext, setupTeliaLtFrontEnd } from './setup';
import { formatErrorCause } from './utils';

type LogArguments = [any, MessageContext, any?];

const formatLog = (message: any, messageContext: MessageContext, error?: any): LogArguments => {
    let formattedContext = messageContext;

    if (message instanceof Error) {
        formattedContext = {
            ...messageContext,
            error: { stack: message.stack, ...message },
            cause: formatErrorCause(message),
        };
    }

    if (error instanceof Error) {
        formattedContext = { ...messageContext, cause: formatErrorCause(error) };
    }

    return error !== undefined ? [message, formattedContext, error] : [message, formattedContext];
};

export const datadogLogger = () => ({
    error: (message: any, messageContext: MessageContext, error?: Error) =>
        setupTeliaLtFrontEnd().logger.error(...formatLog(message, messageContext, error)),
    log: (message: any, messageContext: MessageContext, error?: Error) =>
        setupTeliaLtFrontEnd().logger.log(...formatLog(message, messageContext, error)),
    warn: (message: any, messageContext: MessageContext, error?: Error) =>
        setupTeliaLtFrontEnd().logger.warn(...formatLog(message, messageContext, error)),
    info: (message: any, messageContext: MessageContext, error?: Error) =>
        setupTeliaLtFrontEnd().logger.info(...formatLog(message, messageContext, error)),
});
